import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { LoginAction } from "./redux/actions/LoginActions";

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  login: () => dispatch(LoginAction.login()),
  setUsername: (event) => dispatch(LoginAction.setUsername(event.target.value)),
  setPassword: (event) => dispatch(LoginAction.setPassword(event.target.value)),
  setRemember: (remember) => dispatch(LoginAction.setRemember(remember)),
});

// Convert to function component to use hooks
function LoginScreen(props) {
  const navigate = useNavigate();
  const nameInput = React.useRef();

  React.useEffect(() => {
    if (props.loginState.token) {
      navigate("/data");
    }
  }, [props.loginState.token, navigate]);

  const toggleRemember = () => {
    let newRemember = true;
    try {
      newRemember = !props.loginState.remember;
    } catch (e) {
      //nothing
    }
    props.setRemember(newRemember);
  };

  const enterEmail = (evt) => {
    if (evt.key === "Enter") {
      document.getElementById("password").focus();
    }
  };

  const enterPassword = (evt) => {
    if (evt.key === "Enter") {
      props.login();
    }
  };

  let { username, password, remember, busy } = props.loginState;

  return (
    <>
      <div className="overlay-bg" onClick={props.dismiss}></div>
      <div className="overlay">
        <form className="overlay-content">
          <label htmlFor="email">Sähköposti</label>
          <input
            id="email"
            type="email"
            value={username}
            onChange={props.setUsername}
            onKeyPress={enterEmail}
            ref={nameInput}
          />
          <label htmlFor="password">Salasana</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={props.setPassword}
            onKeyPress={enterPassword}
          />
          <label htmlFor="remember">Muista minut</label>
          <input
            id="remember"
            type="checkbox"
            checked={!!remember}
            onChange={toggleRemember}
          />
          <input
            className="button"
            type="button"
            disabled={busy}
            value="Kirjaudu"
            onClick={props.login}
          />
          <p className="cancel">
            <Link to="/">Peruuta</Link>
          </p>
          <p className="forgot-password">
            <Link to="/salasanan-palautus/">Unohditko salasanasi?</Link>
          </p>
        </form>
      </div>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
